<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Palavras</h3>
        <router-link class="btn btn-success text-white float-right ml-1" :to="{ name: 'admin-word-new' }">Nova palavra</router-link>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-4">
              <h6 class="m-0">Palavras Ativos</h6>
            </div>
            <div class="col-2">
              <button type="button" @click="exportList" class="btn btn-primary">Exportar em .txt</button>
            </div>
            <div class="col-6">
              <form class="main-sidebar__search w-100 d-flex">
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    placeholder="Procurar por algo..."
                    aria-label="Search"
                    v-model="pagination.search"
                  >
                </div>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <word-table :words="word.list" />
            </div>
            <pagination :total-items="word.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import WordService from '_services/rest/modules/word';
import WordTable from '../components/WordListTable.vue';

export default {
  name: 'word-list',
  components: {
    Pagination,
    WordTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    word() {
      const { wordsList } = this.$store.state.word;
      if (wordsList && wordsList.list.length) {
        return wordsList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'getWordsList',
      'setToggle',
      'activeAlert',
    ]),
    getList() {
      this.getWordsList(this.pagination);
    },
    exportList() {
      WordService.exportWords()
        .then(() => {
          this.activeAlert({ message: 'Download finalizado com sucesso!', theme: 'success' });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message}`, theme: 'danger' });
        });
    },
    openImportModal() {
      this.setToggle({ type: 'import_file_modal', bool: true });
    },
  },
  destroyed() {
    Events.$off('update:pagination');
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },

};
</script>
